// extracted by mini-css-extract-plugin
export var label = "_c8-5";
export var slideContainer = "_c8-0";
export var slider = "_c8-1";
export var sliderLg = "_c8-4";
export var sliderMd = "_c8-3";
export var sliderSm = "_c8-2";